import { useEffect, useState } from 'react';

// An explicit choice wins over the OS preference; storage may be unavailable (private mode).
const initialDarkMode = () => {
  try {
    const saved = window.localStorage.getItem('darkMode');
    if (saved !== null) return saved === 'true';
  } catch {
    // Fall through to the OS preference.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
};

/** Theme state applied as the `dark` class on <html> (Tailwind darkMode: 'class'). */
export const useDarkMode = () => {
  const [darkMode, setDarkMode] = useState(initialDarkMode);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);
    try {
      window.localStorage.setItem('darkMode', String(darkMode));
    } catch {
      // The theme just won't be remembered.
    }
  }, [darkMode]);

  return [darkMode, () => setDarkMode((d) => !d)];
};

export default useDarkMode;
